import api from "./api";

const getDSRs = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await api.get(`dsr/?${query}`);
  return response.data;
};

const getDSRById = async (id) => {
  const response = await api.get(`dsr/${id}/`);
  return response.data;
};

const createDSR = async (dsrData) => {
  const response = await api.post("dsr/", dsrData);
  return response.data;
};

const updateDSR = async (id, dsrData) => {
  const response = await api.patch(`dsr/${id}/`, dsrData);
  return response.data;
};

const deleteDSR = async (id) => {
  const response = await api.delete(`dsr/${id}/`);
  return response.data;
};

export const dsrService = {
  getDSRs,
  getDSRById,
  createDSR,
  updateDSR,
  deleteDSR,
};
